RivalIQ.apps.Insights.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.reach = {
        organic: 'Organic',
        viral: 'Viral',
        paid: 'Paid'
    };

});
